import { render } from "./Excellence.vue?vue&type=template&id=1c37dcae&scoped=true"
import script from "./Excellence.vue?vue&type=script&lang=js"
export * from "./Excellence.vue?vue&type=script&lang=js"

import "./Excellence.vue?vue&type=style&index=0&id=1c37dcae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c37dcae"]])

export default __exports__